export default __webpack_public_path__ + "static/media/bfm.7a035216.svg";